.section {
  gap: var(--mirai-ui-space-M);
}

/* colors */
.section.border {
  background-color: var(--mirai-ui-content-border);
}

.section.content {
  background-color: var(--mirai-ui-content);
}

.section.accent {
  background-color: var(--mirai-ui-accent);
}

.section.accent > * > ui-text {
  color: var(--mirai-ui-base);
}

/* layout */
.section.centered {
  justify-content: center;
  gap: var(--mirai-ui-space-L);
}

.section.box {
  padding-bottom: calc(var(--mirai-ui-space-XXL) + var(--mirai-ui-space-L));
}

.section.spaceBetween {
  justify-content: space-between;
}

.texts {
  align-self: flex-start;
}

.image {
  background-color: var(--mirai-ui-content-background);
}

.image.square {
  min-height: var(--mirai-ui-breakpoint-S);
  min-width: var(--mirai-ui-breakpoint-S);
}

.wrapper {
  align-self: center;
  max-width: var(--mirai-ui-breakpoint-content);
  width: 100%;
  gap: var(--mirai-ui-space-S);
}

.wrapper.box {
  margin-top: calc(var(--mirai-ui-space-XXL) * -1);
  background-color: var(--mirai-ui-base);
  box-shadow: var(--mirai-ui-shadow);
  border-radius: var(--mirai-ui-border-radius);
  margin-bottom: var(--mirai-ui-space-XL);
}

.wrapper.centered {
  align-items: center;
}

/* -- home --------------------------------------------------------------- */
.home {
  position: relative;
  justify-content: center;
}

.home .wrapper {
  z-index: 1;
}

.home .backgroundImage {
  background-position: center;
  background-size: cover;
  bottom: 0;
  left: 0;
  opacity: 0.66;
  position: absolute;
  right: 0;
  top: 0;
}

.home .text {
  color: var(--mirai-ui-base);
  text-align: center;
  text-shadow: 0 0 var(--mirai-ui-space-M) rgba(0, 0, 0, 0.33);
}

.testimonials > :first-child {
  max-width: var(--mirai-ui-breakpoint-S);
}

.cards {
  gap: var(--mirai-ui-space-L);
  width: 100%;
  flex: 1;
}

.card {
  background-color: var(--mirai-ui-base);
  border-radius: var(--mirai-ui-border-radius);
  gap: var(--mirai-ui-space-S);
  height: 320px;
  min-width: 256px;
  padding: var(--mirai-ui-space-L) var(--mirai-ui-space-L);
}

.card .avatar {
  background-color: var(--mirai-ui-content-border);
  background-size: cover;
  border-radius: 50%;
  height: var(--mirai-ui-space-XL);
  width: var(--mirai-ui-space-XL);
}

.card .avatar + * {
  margin-bottom: calc(var(--mirai-ui-space-XS) / 2);
}

.card > :last-child {
  align-items: flex-end;
  flex: 1;
  gap: var(--mirai-ui-space-S);
}

.finder.centered {
  margin: 0 auto;
  position: sticky;
  top: var(--mirai-ui-space-M);
}

.finder .resident > [data-role='text'] {
  color: var(--mirai-ui-base);
}

[data-mirai-component='finder'].column {
  background-color: var(--mirai-ui-content-background);
  max-width: calc(var(--mirai-ui-breakpoint-S) - var(--mirai-ui-space-M));
  margin: var(--mirai-ui-space-M);
  padding: var(--mirai-ui-space-M);
  align-self: center;
}

@media only screen and (max-width: 480px) {
  .section {
    padding: var(--mirai-ui-space-XL) var(--mirai-ui-space-M);
  }

  .section.accent.testimonials {
    gap: var(--mirai-ui-space-L);
    padding: var(--mirai-ui-space-XL) 0;
  }

  .testimonials > :first-child {
    padding: 0 var(--mirai-ui-space-M);
  }

  .cards > :first-child {
    margin-left: var(--mirai-ui-space-M);
  }

  .home {
    padding: var(--mirai-ui-space-XXL) var(--mirai-ui-space-M) calc(var(--mirai-ui-space-XXL) * 2)
      var(--mirai-ui-space-M);
  }

  .home .wrapper {
    gap: var(--mirai-ui-space-L);
  }

  .home .slogan {
    font-size: calc(var(--mirai-ui-font-size-headline-1) * 1.66);
    line-height: calc(var(--mirai-ui-line-height-headline-1) * 1.66);
  }

  .home .backgroundImage {
    background-image: url('https://framerusercontent.com/images/wMnYXmJb2xSPIDf60AukEywhD8A.jpg?scale-down-to=960');
  }

  .texts {
    gap: var(--mirai-ui-space-M);
  }

  .image.square {
    min-height: 90svw;
    min-width: 90svw;
  }

  .finder {
    margin-top: calc(var(--mirai-ui-space-L) * -1) !important;
  }
}

@media only screen and (min-width: 481px) {
  .section {
    padding: var(--mirai-ui-space-XXL) var(--mirai-ui-space-M);
  }

  .section.accent.testimonials {
    gap: var(--mirai-ui-space-XXL);
    padding: var(--mirai-ui-space-XXL) 0 var(--mirai-ui-space-XXL) var(--mirai-ui-space-XXL);
  }

  .home {
    min-height: 66svh;
  }

  .home .wrapper {
    gap: var(--mirai-ui-space-XL);
    margin-bottom: var(--mirai-ui-space-M);
  }

  .home .slogan {
    font-size: calc(var(--mirai-ui-font-size-headline-1) * 3);
    line-height: calc(var(--mirai-ui-line-height-headline-1) * 3);
    max-width: calc(var(--mirai-ui-breakpoint-content) * 0.8);
  }

  .home .backgroundImage {
    background-image: url('https://framerusercontent.com/images/wMnYXmJb2xSPIDf60AukEywhD8A.jpg?scale-down-to=1920');
  }

  .home .pitch {
    max-width: 50%;
  }

  body:not([data-mirai-modal='true']) .finder.centered {
    z-index: 1;
  }

  .texts {
    gap: var(--mirai-ui-space-L);
    max-width: 50%;
  }

  .image.square {
    min-height: var(--mirai-ui-breakpoint-S);
    min-width: var(--mirai-ui-breakpoint-S);
  }

  .finder.centered {
    margin-top: calc(var(--mirai-ui-space-XXS) * 8.75 * -1);
  }

  .finder.centered.resident {
    margin-top: calc(var(--mirai-ui-space-S) * 5.75 * -1);
  }

  [data-mirai-component='finder'].column {
    min-width: calc(var(--mirai-ui-breakpoint-S) - var(--mirai-ui-space-M));
  }
}
